import { render } from "./MainSliderComponent.vue?vue&type=template&id=4425ac16&scoped=true"
import script from "./MainSliderComponent.vue?vue&type=script&lang=js"
export * from "./MainSliderComponent.vue?vue&type=script&lang=js"

import "./MainSliderComponent.vue?vue&type=style&index=0&id=4425ac16&scoped=true&lang=css"

import exportComponent from "/var/www/vhosts/dev.soft.team/www/autoringen/autoringen.dev.soft.team/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4425ac16"],['__file',"resources/themes/default/js/components/MainSliderComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4425ac16"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4425ac16', __exports__)) {
    console.log('reload')
    api.reload('4425ac16', __exports__)
  }
  
  module.hot.accept("./MainSliderComponent.vue?vue&type=template&id=4425ac16&scoped=true", () => {
    console.log('re-render')
    api.rerender('4425ac16', render)
  })

}


export default __exports__